// extracted by mini-css-extract-plugin
module.exports = {"root":"PageNotFound_root__OBHyi","redirect_button":"PageNotFound_redirect_button__1bFxi","number":"PageNotFound_number__3GCO5"};